const feedbackFormMixins = {
  data: () => ({
    basicInfo: {
      name: "<Candidate name will be shown here>",
      evalDate: "<Evaluation date will be shown here>",
      panel: "<Panel name will be shown here>",
      modeOfInterview: "<Mode of interview will be shown here>",
    },
    previewFeedback: false,
    shimmerLoader: false,
    aiEditSkill: false,
    loop: 5,
    previewNewModal: false,
    aiLength: null,
    singleSkill: {},
    editID: null,
    globalMarking: "",
    isReloading: false,
    feedbackformdata: {},
    skillEval: false,
    feedbackGiven: false,
    originalData: {},
    mobheader: "",
    button: "",
    msg: "",
    discardSkill: false,
    edit: 0,
    addedskill: false,
    discard: false,
    LoaderStatus: false,
    disableskill: false,
    editskill: false,
    errorSkill: false,
    skillrating: {
      id: null,
      name: "",
      markingType: "",
      mark: "",
      comments: "",
      commentMode: false,
      mandatory: false,
      editskill: false,
    },
    feedbackData: {
      name: "",
      skillratings: [],
      screenshot: false,
    },
    candidateImage: "",
    mandatory: false,
    recommendations: [
      {
        value: true,
        name: "Yes",
      },
      {
        value: false,
        name: "No",
      },
    ],
    options: [
      {
        value: "rating",
        name: "Rating",
      },
      {
        value: "score",
        name: "Score",
      },
    ],
    previousSkillRating: {
      name: "",
      markingType: "",
      commentMode: "",
      mandatory: false,
    },
    ratingvalue: 0,
    Screenshots: [
      {
        value: true,
        name: "Yes",
      },
      {
        value: false,
        name: "No",
      },
    ],
  }),
  watch: {
    "skillrating.name"(newval) {
      if (this.previousSkillRating.name === newval) {
        this.discard = false;
      } else if (this.previousSkillRating.name !== newval) {
        this.discard = true;
      }
    },
  },
  computed: {
    isdisable() {
      let disable;
      if (
        (this.skillrating.name != null &&
          this.skillrating.name != "" &&
          this.skillrating.commentMode) ||
        (this.skillrating.name != null &&
          this.skillrating.name != "" &&
          this.skillrating.markingType != null &&
          this.skillrating.markingType != "")
      ) {
        disable = false;
      } else {
        disable = true;
      }

      return disable;
    },
  },

  methods: {
    openFeedBack() {
      this.previewFeedback = true;
      this.feedbackData.skills = this.feedbackData.skillratings;
    },
    closeModal() {
      this.previewFeedback = false;
    },
    checkSkillEval() {
      if (
        (this.skillrating.markingType != null &&
          this.skillrating.markingType !== "") ||
        this.skillrating.commentMode
      ) {
        this.skillEval = false;
      } else if (
        !this.skillrating.commentMode ||
        this.skillrating.markingType === ""
      ) {
        this.skillEval = true;
      }
      this.feedbackData.skillratings = this.feedbackData.skillratings.map(
        (skill) => {
          return {
            ...skill,
            markingType: this.skillrating.markingType,
          };
        }
      );
    },
    clearform() {
      this.name = "";

      this.skillrating = {
        name: "",
        markingType: "",
        mark: "",
        comments: "",
        commentMode: false,
      };

      this.skillratings = [];
    },
    resetvalidation() {
      if (this.skillrating.name == "" || this.skillrating.name == null) {
        this.errorsameskill = false;
      }
    },
    cancelskill() {
      if (this.edit !== null) {
        this.skillrating.name = this.previousSkillRating.name;

        this.skillrating.commentMode = this.previousSkillRating.commentMode;

        this.mandatory = this.previousSkillRating.mandatory;
        this.discard = false;
      } else {
        this.skillrating.name = "";
        this.skillrating.commentMode = false;
        this.mandatory = false;
        this.editskill = false;
      }
      this.disableskill = true;
    },
  },
};
export default feedbackFormMixins;
